const getOpenReason = (reason) => {
  switch (reason) {
    case 0:
      return 'Open by user';
    case 1:
      return 'Open by EA';
    case 2:
      return 'Open by user';
    case 16:
      return 'Open by user';
    case 17:
      return 'Open by user';
    default:
      return '-';
  }
};

const getCloseReason = (reason) => {
  switch (reason) {
    case 0:
      return 'Close by user';
    case 1:
      return 'Expert Advisor';
    case 2:
      return 'Close by user';
    case 3:
      return 'Stop Loss';
    case 4:
      return 'Take Profit';
    case 5:
      return 'Stop Out';
    case 16:
      return 'Close by user';
    case 17:
      return 'Close by user';
    default:
      return '-';
  }
};

const getOrderReason = (reason) => {
  switch (reason) {
    case 0:
      return 'Open by user';
    case 1:
      return 'Open by EA';
    case 2:
      return 'Open by user';
    case 16:
      return 'Open by user';
    case 17:
      return 'Open by user';
    default:
      return '-';
  }
};

export { getOpenReason, getCloseReason, getOrderReason };
